export const latestInteractionsPath = '/letzte-beratungen'
